import { useEffect, useMemo, useState } from "react";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import {
  ArrowClockwise,
  FilterCircle,
  HddNetworkFill,
  Trash,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import Table from "../../components/table/Table";
import Footer from "../../components/admin/footer/Footer";
import moment from "moment";
import Loader from "../../components/common/Loader";
import {
  getOLT,
  getOltUsers,
  getOnuLaserInformation,
  oltAndCustomerDelete,
} from "../../features/oltApi";
import { useDispatch, useSelector } from "react-redux";
import useISPowner from "../../hooks/useISPOwner";
import { badge } from "../../components/common/Utils";
import { Accordion } from "react-bootstrap";
import useDataState from "../../hooks/useDataState";

const OLTUsers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Get user & current user data form useISPOwner hooks
  const { role, ispOwnerId, bpSettings, userData } = useISPowner();
  // get user data set from useDataState hooks
  const { filterOptions, setFilterOption } = useDataState();

  //---> Get ISP owner or reseller olt users from redux store
  const users = useSelector((state) => state?.olt.users);

  //---> Get ISP owner or reseller olt from redux store
  const olts = useSelector((state) => state?.olt.olt);

  //---> Loading State
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [laserLoading, setLaserLoading] = useState(false);
  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");
  const [oltuser, setOltUser] = useState([]);

  useEffect(() => {
    getOltUsers(ispOwnerId, setIsLoading, dispatch);

    !olts?.length && getOLT(ispOwnerId, setLoading, dispatch);
  }, [ispOwnerId]);

  const reloadHandler = () => {
    getOltUsers(ispOwnerId, setIsLoading, dispatch);
  };

  const oltMap = new Map(olts.map((olt) => [String(olt.id), olt]));
  const findOltVendor = (id) => oltMap.get(String(id)) || null;

  const onClickFilter = () => {
    let arr = [...users];
    if (filterOptions.olt) {
      arr = arr.filter((user) => user.olt === filterOptions.olt);
    }
    setOltUser(arr);
  };

  const handleOLTUserLaserInformation = async (id) => {
    await getOnuLaserInformation(dispatch, id, setLaserLoading);
  };

  const handleOLTCustomerDelete = async (id) => {
    oltAndCustomerDelete(dispatch, id);
  };

  const onClickReset = () => {
    setFilterOption({});
    setOltUser(users);
  };
  useEffect(() => {
    if (users) {
      setOltUser(users);
    }
    onClickFilter();
  }, [users, filterOptions.olt]);

  const columns = useMemo(
    () => [
      {
        width: "6%",
        Header: t("id"),
        accessor: "customer.customerId",
        Cell: ({ row: { original } }) => (
          <div className="text-center">
            <p>{original?.customer?.customerId}</p>
            <p>{badge(original?.status)}</p>
          </div>
        ),
      },
      {
        width: "12%",
        Header: t("name"),
        accessor: "customer.name",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.customer?.name}</p>
            <p>{original?.address}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("macAddress"),
        accessor: "macAddress",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.macAddress}</p>
            <p>{original?.onuMacAddress}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("oltPorts"),
        accessor: "olt",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{findOltVendor(original?.olt)?.name}</p>
            <p>{original?.ports}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("powerDbm"),
        accessor: "rxPowerDbm",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.rxPowerDbm}</p>
            <p>{original?.txPowerDbm}</p>
          </div>
        ),
      },
      {
        width: "7%",
        Header: t("distance"),
        accessor: "distance",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.distance}</p>
            <p>{original?.deregReason}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("parameter"),
        accessor: "voltage",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.voltage}</p>
            <p>{original?.temperature}</p>
          </div>
        ),
      },
      {
        width: "7%",
        Header: t("onu"),
        accessor: "onuModel",
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.onuModel}</p>
            <p>{original?.onuVendor}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("lastUpdate"),
        accessor: "updatedAt",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("YYYY/MM/DD hh:mm A");
        },
      },
      // {
      //   width: "5%",
      //   Header: () => <div className="text-center">{t("action")}</div>,
      //   id: "option",
      //   Cell: ({ row: { original } }) => (
      //     <div className="d-flex justify-content-center align-items-center gap-2">
      //       <button
      //         title={t("checkConnection")}
      //         className="btn btn-sm btn-outline-primary"
      //         onClick={() =>
      //           handleOLTUserLaserInformation(original?._id || original?.id)
      //         }
      //       >
      //         {laserLoading ? <Loader /> : <HddNetworkFill size={18} />}
      //       </button>
      //     </div>
      //   ),
      // },
      {
        width: "5%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",

        Cell: ({ row: { original } }) => {
          return !findOltVendor(original?.olt) || !original?.customer ? (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <button
                title={t("checkConnection")}
                className="btn btn-sm btn-outline-danger"
                onClick={() =>
                  handleOLTCustomerDelete(original?._id || original?.id)
                }
              >
                {laserLoading ? <Loader /> : <Trash size={18} />}
              </button>
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <button
                title={t("checkConnection")}
                className="btn btn-sm btn-outline-primary"
                onClick={() =>
                  handleOLTUserLaserInformation(original?._id || original?.id)
                }
              >
                {laserLoading ? <Loader /> : <HddNetworkFill size={18} />}
              </button>
            </div>
          );
        },
      },
    ],
    [t, olts, laserLoading],
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector ">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <h2> {t("oltUsers")} </h2>

                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>
                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <div className="displayGrid6">
                          <select
                            className="form-select mt-0"
                            value={filterOptions.olt || ""}
                            onChange={(e) =>
                              setFilterOption({
                                ...filterOptions,
                                olt: e.target.value,
                              })
                            }
                          >
                            <option value="" defaultValue>
                              {t("olt")}
                            </option>
                            {olts.map((olt, key) => (
                              <option key={key} value={olt.id}>
                                {olt.name}
                              </option>
                            ))}
                          </select>

                          <div className="displayGrid1">
                            <button
                              className="btn btn-outline-primary"
                              type="button"
                              onClick={onClickFilter}
                            >
                              {t("filter")}
                            </button>
                            <button
                              className="btn btn-outline-primary"
                              type="button"
                              onClick={onClickReset}
                            >
                              {t("reset")}
                            </button>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="collectorWrapper pb-2">
                    <Table
                      isLoading={isLoading}
                      columns={columns}
                      data={oltuser}
                    />
                  </div>
                </div>
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>
    </>
  );
};

export default OLTUsers;
